import { createFeature, createReducer, on } from '@ngrx/store';
import { addTask, removeTask } from 'src/app/tasks-queue/store/tasks-queue.actions';
import { ITask, ITasksQueueState, TaskType } from './tasks-queue.types';

const initState: ITasksQueueState = {
  tasks: [],
};

const dropTask = (tasks: ITask[], type: TaskType) => tasks.filter(task => task.type !== type);

const TASKS_QUEUE_FEATURE_NAME = 'tasksQueue' as const;
export const tasksQueueFeature = createFeature({
  name: TASKS_QUEUE_FEATURE_NAME,
  reducer: createReducer(
    initState,

    on(addTask, (state, { taskType, params }): ITasksQueueState => ({
      ...state,
      tasks: [
        ...dropTask(state.tasks, taskType),
        {
          type: taskType,
          params,
        },
      ],
    })),

    on(removeTask, (state, { taskType }): ITasksQueueState => ({
      ...state,
      tasks: dropTask(state.tasks, taskType),
    })),
  ),
});

export const {
  selectTasks,
} = tasksQueueFeature;
